import {Injectable} from '@angular/core';
import {checkIfValidURL} from '../url-validator.directive';
import {RdapServerVO} from '../../generate/TopLevelDomainVO';
import {checkIfASCII} from '../../util/CommonFunctions';

@Injectable()
export class RdapServersValidatorService {

  constructor() {
  }

  validateRdapServers(newRdapServer: RdapServerVO, modifiedRDAPServers: Array<RdapServerVO>): string[] {
    let rdapErrors: string[] = [];
    if (!checkIfASCII(newRdapServer.url)) {
      rdapErrors.push("Invalid URL, URL cannot contain non-ASCII characters");
    }

    if (!checkIfValidURL(newRdapServer.url)) {
      rdapErrors.push("Invalid URL");
    }

    modifiedRDAPServers.forEach(rdap => {
      if(rdap.url === newRdapServer.url){
        rdapErrors.push("Duplicate RDAP Server");
      }
    });

    return rdapErrors;
  }
}
